import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { UploadxModule } from 'laravel-ngx-uploadx';

@NgModule({
    imports: [
        HttpClientModule,
        UploadxModule
    ],
})
export class HttpModule { }
